export default "/kiban/_next/static/images/black-3cde06aaade779b1cde495a734c8b2b4.png";